<template>
  <div class="vx-card">
    <div class="flex justify-between" style="padding: 1.5rem;">
      <div class="font-bold" style="font-size: 14px;"><i class="dot" /> 주요 안전보건관리 이행 현황</div>
      <div class="hidden">자세히 보기 ></div>
    </div>
    <div style="padding: 1.5rem;">
      <apexchart ref="apexchart" type="bar" :options="chartOptions" :series="getSeries" height="300" />
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'SummaryImplementationStatusChart',
  props: {
    percent1: {
      type: Number,
      default: 0,
    },
    percent2: {
      type: Number,
      default: 0,
    },
    percent3: {
      type: Number,
      default: 0,
    },
  },
  mounted() {
    this.series[0].data = [this.percent1, this.percent2, this.percent3];
  },
  computed: {
    getSeries() {
      return this.series;
    }
  },
  data() {
    return {
      // 그래프에서 추출하려고 하는 시설물 분류 값, 그 외에는 "기타"에 포함시킨다
      targetFacilityCategory: ['기계공학과', '토목공학과', '건축공학과', '법학과'],
      series: [
        {
          data: [0, 0, 0],
        }
      ],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 300,
        },
        plotOptions: {
          bar: {
            barHeight: '30%',
            horizontal: true,
            distributed: true,
            endingShape: 'rounded',
            dataLabels: {
              position: 'bottom',
            },
            offsetY: 10,
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '14px',
            fontWeight: 'normal',
            colors: ['#000000']
          },
          textAnchor: 'start',
          offsetX: -0,
          offsetY: -30,
          formatter (val, opt) {
            return `${opt.w.globals.labels[opt.dataPointIndex]  }`; //:  ${  val  }%`
          },
        },
        grid: {
          show: false,
        },
        stroke: {
          show: false,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: ['위험성평가 위험도 현황', '안전보건 점검 미이행 현황', '안전보건 교육 미이행 현황'],
          max: 100,
        },
        colors: ['#4082FF', '#21D59B', '#FFC700'],
        yaxis: {
          labels: {
            show: false
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter (val) {
              return `${val  }%`
            }
          }
        }
      }
    }
  },
  emits: ['update:checked-count'],
  watch: {
    percent1: {
      handler(newValue) {
        this.$set(this.series[0].data, 0, newValue);
      },
      immediate: true,
    },
    percent2: {
      handler(newValue) {
        this.$set(this.series[0].data, 1, newValue);
      },
      immediate: true,
    },
    percent3: {
      handler(newValue) {
        this.$set(this.series[0].data, 2, newValue);
      },
      immediate: true,
    },
    getSeries: {
      deep: true,
      handler() {
        this.updateChartData();
      }
    }
  },
  methods: {
    updateChartData() {
      this.$nextTick(() => {
        if (this.$refs.apexchart) {
          this.$refs.apexchart.updateSeries(this.getSeries);
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
